<template>
  <div v-if="visible" class="mcl-picker-overlay" @click.self="onCancel">
    <div class="mcl-picker-modal" role="dialog" aria-modal="true" aria-labelledby="mcl-picker-title">
      <div class="mcl-picker-header">
        <div class="mcl-picker-header__title-row">
          <font-awesome-icon :icon="['fas', 'user']" class="mcl-picker-header__icon" />
          <h2 id="mcl-picker-title" class="mcl-picker-header__title">Select contacts</h2>
        </div>
        <button type="button" class="mcl-picker-close" title="Close" @click="onCancel">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>

      <div class="mcl-picker-search-wrap">
        <font-awesome-icon :icon="['fas', 'search']" class="mcl-picker-search-icon" />
        <input
          v-model="localSearch"
          type="text"
          class="mcl-picker-search"
          placeholder="Search for contacts"
          @input="onSearchInput"
        />
      </div>

      <div class="mcl-picker-toolbar">
        <label class="mcl-picker-select-all">
          <input type="checkbox" :checked="allVisibleSelected" @change="toggleSelectAll" />
          <span>Select all</span>
        </label>
        <span class="mcl-picker-count">{{ filteredContacts.length }} contacts</span>
      </div>

      <div class="mcl-picker-list">
        <p v-if="isLoading" class="mcl-picker-empty">Loading contacts…</p>
        <p v-else-if="filteredContacts.length === 0" class="mcl-picker-empty">No contacts found.</p>
        <label
          v-for="contact in filteredContacts"
          :key="contact.id + '-' + contact.email"
          class="mcl-picker-row"
        >
          <input
            type="checkbox"
            :checked="isSelected(contact)"
            @change="toggleContact(contact)"
          />
          <span class="mcl-picker-row__avatar">{{ contactInitial(contact) }}</span>
          <span class="mcl-picker-row__meta">
            <span class="mcl-picker-row__name">{{ contact.name }}</span>
            <span class="mcl-picker-row__email">{{ contact.email }}</span>
          </span>
        </label>
      </div>

      <div class="mcl-picker-footer">
        <div class="mcl-picker-footer__left">
          <span class="mcl-picker-selected-count">{{ selectedDraft.length }} selected</span>
          <button
            v-if="selectedDraft.length > 0"
            type="button"
            class="mcl-picker-clear"
            @click="clearSelection"
          >
            Clear
          </button>
        </div>
        <button type="button" class="mcl-picker-insert" @click="onInsert">Insert</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPickerModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    contacts: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    initialSelected: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  emits: ["close", "insert", "search"],
  data: function () {
    return {
      localSearch: "",
      selectedDraft: [],
      searchTimer: null,
    };
  },
  computed: {
    filteredContacts: function () {
      var list = this.contacts || [];
      var q = (this.localSearch || "").trim().toLowerCase();
      if (!q) {
        return list;
      }
      return list.filter(function (c) {
        var name = c.name ? c.name.toLowerCase() : "";
        var email = c.email ? c.email.toLowerCase() : "";
        var partner = c.partner_name ? c.partner_name.toLowerCase() : "";
        return name.indexOf(q) !== -1 || email.indexOf(q) !== -1 || partner.indexOf(q) !== -1;
      });
    },
    allVisibleSelected: function () {
      var visible = this.filteredContacts;
      if (!visible || visible.length === 0) {
        return false;
      }
      var self = this;
      for (var i = 0; i < visible.length; i++) {
        if (!self.isSelected(visible[i])) {
          return false;
        }
      }
      return true;
    },
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.localSearch = "";
        this.selectedDraft = this.cloneRecipients(this.initialSelected);
        this.$emit("search", "");
      }
    },
    initialSelected: function (val) {
      if (this.visible) {
        this.selectedDraft = this.cloneRecipients(val);
      }
    },
  },
  beforeUnmount: function () {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    cloneRecipients: function (list) {
      var out = [];
      if (!list) {
        return out;
      }
      for (var i = 0; i < list.length; i++) {
        out.push({
          email: list[i].email,
          name: list[i].name || "",
          id: list[i].id || null,
        });
      }
      return out;
    },
    contactInitial: function (contact) {
      if (contact && contact.name) {
        return contact.name.charAt(0).toUpperCase();
      }
      return "?";
    },
    recipientKey: function (contact) {
      return (contact.email || "").toLowerCase();
    },
    isSelected: function (contact) {
      var key = this.recipientKey(contact);
      for (var i = 0; i < this.selectedDraft.length; i++) {
        if (this.recipientKey(this.selectedDraft[i]) === key) {
          return true;
        }
      }
      return false;
    },
    toggleContact: function (contact) {
      var key = this.recipientKey(contact);
      var idx = -1;
      for (var i = 0; i < this.selectedDraft.length; i++) {
        if (this.recipientKey(this.selectedDraft[i]) === key) {
          idx = i;
          break;
        }
      }
      if (idx >= 0) {
        this.selectedDraft.splice(idx, 1);
        return;
      }
      this.selectedDraft.push({
        id: contact.id,
        email: contact.email,
        name: contact.name || "",
      });
    },
    toggleSelectAll: function () {
      var self = this;
      if (this.allVisibleSelected) {
        var visibleKeys = {};
        this.filteredContacts.forEach(function (c) {
          visibleKeys[self.recipientKey(c)] = true;
        });
        this.selectedDraft = this.selectedDraft.filter(function (r) {
          return !visibleKeys[self.recipientKey(r)];
        });
        return;
      }
      this.filteredContacts.forEach(function (c) {
        if (!self.isSelected(c)) {
          self.selectedDraft.push({
            id: c.id,
            email: c.email,
            name: c.name || "",
          });
        }
      });
    },
    clearSelection: function () {
      this.selectedDraft = [];
    },
    onSearchInput: function () {
      var self = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(function () {
        self.$emit("search", self.localSearch);
      }, 300);
    },
    onCancel: function () {
      this.$emit("close");
    },
    onInsert: function () {
      this.$emit("insert", this.cloneRecipients(this.selectedDraft));
    },
  },
};
</script>

<style scoped>
.mcl-picker-overlay {
  position: fixed;
  inset: 0;
  z-index: 120;
  background: rgba(32, 33, 36, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.mcl-picker-modal {
  width: 100%;
  max-width: 520px;
  max-height: 85vh;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mcl-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem 0.5rem;
}

.mcl-picker-header__title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.mcl-picker-header__icon {
  color: #1a73e8;
  font-size: 1.125rem;
}

.mcl-picker-header__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 500;
  color: #202124;
}

.mcl-picker-close {
  border: none;
  background: transparent;
  color: #5f6368;
  cursor: pointer;
  padding: 0.35rem;
  border-radius: 9999px;
}

.mcl-picker-close:hover {
  background: #f1f3f4;
}

.mcl-picker-search-wrap {
  position: relative;
  padding: 0.5rem 1.25rem 0.75rem;
}

.mcl-picker-search-icon {
  position: absolute;
  left: 1.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9aa0a6;
  font-size: 0.875rem;
}

.mcl-picker-search {
  width: 100%;
  padding: 0.625rem 0.75rem 0.625rem 2.25rem;
  border: 1px solid #dadce0;
  border-radius: 24px;
  font-size: 0.875rem;
  outline: none;
}

.mcl-picker-search:focus {
  border-color: #1a73e8;
  box-shadow: 0 0 0 1px #1a73e8;
}

.mcl-picker-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem 0.5rem;
  border-bottom: 1px solid #e8eaed;
  font-size: 0.8125rem;
  color: #5f6368;
}

.mcl-picker-select-all {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;
}

.mcl-picker-list {
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
  max-height: 360px;
}

.mcl-picker-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1.25rem;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f4;
}

.mcl-picker-row:hover {
  background: #f8f9fa;
}

.mcl-picker-row__avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  background: #e8f0fe;
  color: #1a73e8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.mcl-picker-row__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mcl-picker-row__name {
  font-size: 0.875rem;
  color: #202124;
  font-weight: 500;
}

.mcl-picker-row__email {
  font-size: 0.8125rem;
  color: #5f6368;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mcl-picker-empty {
  padding: 2rem;
  text-align: center;
  color: #5f6368;
  font-size: 0.875rem;
}

.mcl-picker-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.25rem;
  border-top: 1px solid #e8eaed;
  background: #f8f9fa;
}

.mcl-picker-footer__left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.8125rem;
  color: #5f6368;
}

.mcl-picker-clear {
  border: none;
  background: none;
  color: #1a73e8;
  cursor: pointer;
  font-size: 0.8125rem;
}

.mcl-picker-insert {
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}

.mcl-picker-insert:hover {
  background: #1765cc;
  box-shadow: 0 1px 2px rgba(26, 115, 232, 0.45);
}
</style>
